import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Hero from '../../components/feature/Hero';
import Features from '../../components/feature/Features';
import Gallery from '../../components/feature/Gallery';
import Download from '../../components/feature/Download';
import Footer from '../../components/feature/Footer';
import { useAppConfig } from '../../hooks/useAppConfig';

export default function Home() {
  const appConfig = useAppConfig();
  
  // Update document title based on app
  useEffect(() => {
    document.title = `${appConfig.name} - Premium 4K HD Wallpapers`;
  }, [appConfig]);
  
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <main>
        <Hero />
        <Features />
        <Gallery />
        <Download />
      </main>
      <Footer />
    </div>
  );
}
